import React from 'react'
import './FeatureCards.css'
import { LuAward, LuFlaskConical, LuHeart, LuStore } from 'react-icons/lu'

const features = [
  {
    icon: LuAward,
    stat: '+35 Anos',
    label: 'De experiência e pioneirismo',
    description: 'Sendo referência nacional em banco de sêmen de doadores'
  },
  {
    icon: LuHeart,
    stat: 'Milhares',
    label: 'De Sonhos realizados',
    description: 'Desde 1992 construindo famílias lindas e saudáveis'
  },
  {
    icon: LuStore,
    stat: '+1000',
    label: 'Amostras disponíveis',
    description: 'De doadores nacionais e importados com perfis completos e detalhados'
  },
  {
    icon: LuFlaskConical,
    stat: 'One Stop Shop',
    label: 'O único tudo em um',
    description: 'Todos os doadores e conveniências em um só lugar'
  }
]

const FeatureCards: React.FC<any> = () => {
  return (
    <section>
      <div className="row align-items-stretch mx-n2" style={{ rowGap: '12px' }}>
        {features.map(({ icon: Icon, stat, label, description }) => (
          <div key={stat + label} className="col-12 col-md-3 d-flex px-2">
            <div className="feature-card card w-100 border-0 h-100 p-0" style={{ borderRadius: 16, boxShadow: '0 1px 8px rgba(0,0,0,0.07)' }}>
              <div className="card-body d-flex flex-lg-column gap-10 align-items-start justify-content-start p-4" style={{ borderRadius: 16 }}>
                <div className="feature-card-icon mb-3 d-flex align-items-center justify-content-center rounded-circle" style={{ width: 52, height: 52, backgroundColor: '#fcf0f6' }}>
                  <Icon size={22} style={{ color: '#FA5A84' }} />
                </div>
                <div>
                  <p className="feature-card-stat font-weight-bold mb-1 text-dark">{stat}</p>
                  <p className="feature-card-label font-weight-bold text-dark mb-1">{label}</p>
                  <p className="feature-card-description text-muted mb-0">{description}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

export default FeatureCards
